import { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/lib/auth-context';
import {
  isAllowedExternalRedirect,
  rememberAuthRedirect,
  resolveAuthRedirect,
  redirectToExternalAuth,
} from '@/lib/auth-redirect';

/**
 * After login/signup, send users back to the marketing site when ?redirect= is set.
 * Runs globally so React Router cannot race ahead to /accounts.
 */
export default function AuthRedirectListener() {
  const { user, loading } = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const redirectParam = searchParams.get('redirect');

  useEffect(() => {
    if (redirectParam) {
      rememberAuthRedirect(redirectParam);
    }
  }, [redirectParam]);

  useEffect(() => {
    if (loading || !user) return;

    const target = resolveAuthRedirect(redirectParam);
    if (!isAllowedExternalRedirect(target)) return;

    redirectToExternalAuth(target);
  }, [loading, user, redirectParam, location.pathname, location.search]);

  return null;
}
